import FloatingPopup from "meta/ui2/floating-popup";
import UserInfo from "screens/Root/components/UserInfo";
import { useAppSelector } from "screens/Root/hooks/useAppSelector";
import ReactDOM from "react-dom";
import { IconButton } from "../../components/IconButton";
const HeaderUserIcon = () => {
    const user = useAppSelector((state) => state).root.appSettings.User;
    const userName = user.UserOpId;
    const handleClick = () => {
        const thisBoundingRect = document
            .getElementById("top-container")
            ?.getBoundingClientRect();
        new FloatingPopup({
            popupContent: "",
            right: "0",
            top: thisBoundingRect?.bottom + "px",
            className: "user-info-popup",
            bottom: undefined,
            left: undefined,
        }).show();
        ReactDOM.render(<UserInfo user={user}/>, document.getElementsByClassName("ui2-floating-popup user-info-popup")[0]);
    };
    return (<IconButton type="font-awesome" tooltip="Open Details" onClick={handleClick} title={userName} identification="header-user" size={19}>
      user-circle
    </IconButton>);
};
export default HeaderUserIcon;
